import React from 'react';

import DisplayNames from './enums';

import { Icon, useColorMode } from 'index';

const AccordionIcon = (): React.ReactElement => {
  const { colorMode } = useColorMode();
  const color = colorMode === 'light' ? 'grey.base' : 'silver.light';

  return <Icon boxSize="24px" color={color} type="Chevron" />;
};

AccordionIcon.displayName = DisplayNames.AccordionIcon;

export default AccordionIcon;
